function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5BFC\\u822A\\u5207\\u56FE",
  transform: "translate(-32.000000, -128.000000)"
}, React.createElement("rect", {
  fill: "transparent",
  x: 0,
  y: 0,
  width: 200,
  height: 257
}), React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(0.000000, 112.000000)"
}, React.createElement("rect", {
  id: "\\u77E9\\u5F62\\u5907\\u4EFD-13",
  fill: "transparent",
  opacity: 0.05,
  x: 0,
  y: 0,
  width: 200,
  height: 48
}), React.createElement("g", {
  id: "default-template",
  transform: "translate(32.000000, 16.000000)",
  fillRule: "nonzero"
}, React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "transparent",
  opacity: 0,
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), React.createElement("path", {
  d: "M3.31291029,3.62144421 L3.31291029,13.6870897 L12.2844639,13.6870897 L12.2844639,15 L3.96936543,15 C2.91778702,15 2.05172922,14.1738244 2.00218819,13.1234136 L2,13.0306346 L2,3.62144421 L3.31291029,3.62144421 Z M14.3247265,2.31291029 L14.3247265,11.5698031 C14.3247265,12.2949034 13.7369165,12.8827134 13.0118162,12.8827134 L4.18380745,12.8827134 L4.18380745,2.31291029 C4.18380745,1.58780996 4.77161741,1 5.49671774,1 L13.0118162,1 C13.7369165,1 14.3247265,1.58780996 14.3247265,2.31291029 Z M5.49671774,2.31291029 L5.49671774,11.5698031 L13.0118162,11.5698031 L13.0118162,2.31291029 L5.49671774,2.31291029 Z M12.0897155,5.83851203 L8.6,9.29321664 L6.78774618,7.48140045 L7.71553612,6.55317288 L8.60437638,7.44157549 L11.166302,4.90547047 L12.0897155,5.83851203 Z",
  id: "\\u5F62\\u72B6",
  fill: "#333333"
})))));

var SvgIconOrder = function SvgIconOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconOrder.2c57c830.svg";
export { ForwardRef as ReactComponent };